import { Controller } from "@hotwired/stimulus";

class WorldpayController extends Controller {
  static outlets = ["payment-update", "checkout-forms"];
  static targets = ["paymentSuccess", "paymentError", "paymentCancelled"];

  connect() {
    this.paymentUpdateOutlet.addAsyncSubmitInterrupt(this.handleSubmit);

    if (this.hasCheckoutFormsOutlet) {
      this.checkoutFormsOutlet.addErrorListener(this.handleSubmitError);
    } else {
      this.paymentUpdateOutlet.enableSubmit();
    }
  }

  disconnect() {
    this.paymentUpdateOutlet.removeAsyncSubmitInterrupt(this.handleSubmit);
  }

  handleSubmit = () => {
    if (this.pendingResolve) {
      this.#resolvePendingPromise(false);
    }

    this.#loadWorldpayForm();

    return new Promise((resolve, _reject) => (this.pendingResolve = resolve));
  };

  handleSubmitError = () => {
    this.#hideWorldpayForm();
  };

  paymentSuccessTargetConnected() {
    this.#resolvePendingPromise(true);
  }

  paymentErrorTargetConnected(target) {
    this.#resolvePendingPromise(false);

    this.paymentUpdateOutlet.setCustomError(target.dataset.paymentErrorMessage);
  }

  paymentCancelledTargetConnected() {
    this.#resolvePendingPromise(false);

    this.#hideWorldpayForm();
  }

  #hideWorldpayForm() {
    const url = new URL(window.location.href);
    url.searchParams.set("show_worldpay_form", "false");
    Turbo.visit(url, { frame: "worldpay_form_wrapper" });
  }

  #loadWorldpayForm() {
    const url = new URL(window.location.href);

    url.searchParams.set("show_worldpay_form", "true");
    url.searchParams.set("phone", this.#inputValue("customer_phone"));

    // The location <select> only exists on the multi-location dropdown flow. On the deep-link
    // (?patheon_site_id=) and Checkout Locator (?searched_for_location_id=) flows it is absent, so
    // only override patheon_site_id when a value is actually selected. Otherwise we'd send
    // "patheon_site_id=undefined", which clobbers the location already encoded in the URL and makes
    // the reload fall back to the group's default processor (hiding the Worldpay iframe).
    const selectedSiteId = this.#inputValue("location-select");
    if (selectedSiteId) {
      url.searchParams.set("patheon_site_id", selectedSiteId);
    }

    Turbo.visit(url, { frame: "worldpay_form_wrapper" });
  }

  #resolvePendingPromise(value) {
    if (this.pendingResolve) {
      this.pendingResolve(value);
      this.pendingResolve = null;
    }
  }

  #inputValue(elementId) {
    return document.getElementById(elementId)?.value;
  }
}

export default WorldpayController;
